<template>
    <div class="tile-wrapper">
        <a :href="href" class="tile tile--small"
           :class="{'tile--no-top': !category}"
        >
            <div class="tile__top tile__top--small" v-if="category">
                <div class="tile__top-title tile__top-title--small">
                    {{ category }}
                </div>
            </div>
            <div class="tile__middle">
                <div class="lazy-wrapper"
                    :class="{'lazy-wrapper--njam-tile-medium': typeSlug !== 'blog', 'lazy-wrapper--tile-medium': typeSlug === 'blog'}"
                >
                    <img class="tile__img lazy-wrapper__img" :src="image" :alt="title">
                </div>
            </div>
            <div class="tile__bottom">
                <h3 class="tile__title tile__title--small">
                    {{ title }}
                </h3>
            </div>
        </a>
    </div>
</template>
<script>

export default {
    name: "ResultItem",
    props: ['title', 'href', 'category', 'image', 'typeSlug']
}
</script>